import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";

const TextFieldCompnent = ({
  type,
  onlyDigits,
  label,
  change,
  value,
  name,
  blur,
  touched,
  error,
  colum,
  row,
  num,
  ...otherProps
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const gridColumn = colum || undefined;
  const gridRow = row || undefined;

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  const getInputProps = () => {
    if (type === "number") {
      if (onlyDigits) {
        return {
          min: num || 0,
          onKeyDown: (e) => {
            if (e.key === "-" || e.key === ".") {
              e.preventDefault();
            }
          },
          step: "1",
        };
      } else {
        return {
          min: num || 0,
          onKeyDown: (e) => {
            if (e.key === "-") {
              e.preventDefault();
            }
          },
          step: "any",
        };
      }
    }
    return {};
  };
  return (
    <TextField
      variant="filled"
      type={type === "password" ? (showPassword ? "text" : "password") : type}
      label={label}
      onBlur={blur}
      onChange={change}
      value={value}
      name={name}
      error={!!touched && !!error}
      helperText={touched && error}
      sx={{ gridColumn: gridColumn, gridRow: gridRow }}
      inputProps={getInputProps()}
      InputProps={
        type === "password"
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleTogglePassword} edge="end">
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }
          : undefined
      }
      {...otherProps}
    />
  );
};

export default TextFieldCompnent;
